module.exports = __webpack_public_path__ + "static/media/home_consulting_512.0ce04bb4.png";